import { createSlice } from "@reduxjs/toolkit";

type State = {
 closedAlerts: string[];

};

const initialState: State = {
    closedAlerts: [],
};

const sessionSlice = createSlice({
    name: "session",
    initialState,
    reducers: {
        resetSession: () => initialState,
        closeAlert: (state, { payload }: { payload: string }) => {
            state.closedAlerts.push(payload);
        }
    },
});

export const { resetSession, closeAlert } = sessionSlice.actions;

export default sessionSlice.reducer;
